export default "__VITE_ASSET__Cpo7pNEB__"